import { render, staticRenderFns } from "./NumerationDocument.vue?vue&type=template&id=dbb9e956&"
import script from "./NumerationDocument.vue?vue&type=script&lang=js&"
export * from "./NumerationDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports